<template>
	<ui-modal-template>
		<template v-slot:title>
			<span>Zahlungsmethode bestätigen</span>
		</template>
		<template v-slot:content>
			<div class="px-6 mt-3 py-3">
				<div class="px-6">
					<p class="mb-3 text-lg font-bold">Prüfen Sie Ihre Angaben:</p>
				</div>

				<div class="px-6">
					<div class="py-3">
						<p class="font-semibold">Zahlungsmethode:</p>
						<p class="flex my-2">
							<span class="flex">{{ __(selectedPaymentMethod.code)}}</span> <img class="mx-3 min-w-4 max-h-6" :src="selectedPaymentMethod.image">
						</p>

						<p v-if="selectedPaymentMethod.code === 'directdebit'">
							<span class="font-semibold">Ihre Bankverbindung:</span>
							<span class="flex">Inhaber: {{ formData.bank_account.owner }}</span>
							<span class="flex">IBAN: {{ formData.bank_account.iban }}</span>

							<span v-if="error" class="my-3 text-red-600">
								{{ error }}
							</span>
						</p>

					</div>

					<div v-if="selectedPaymentMethod.address_required"class="py-3">
						<p class="font-semibold">Ihre Rechnungsadresse:</p>
						<p class="mb-0">{{ formData.address.company_name }}</p>
						<p>{{ formData.address.street }} {{ formData.address.house_number }}</p>
						<p>{{ formData.address.postal_code }} {{ formData.address.city }}</p>
						<p>Rechnungs-Email: {{ formData.address.email }}</p>
					</div>

				</div>
			</div>

			<div class="bg-gray-100 p-6">
				<div class="flex justify-between px-6">
					<ui-button
						:disabled="loading"
						v-on:click="$bus.$emit('wizard:back', 'booking')"
						label="Zurück"
					/>

					<ui-button
						:disabled="loading"
						v-on:click="submitForm()"
						label="Speichern"
					/>
				</div>
			</div>
		</template>
		<!-- devide -->
	</ui-modal-template>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import {formatLocalizedNumber} from "../../cropOptions";
import toast from '../../services/toast';

export default {
	props: {
		formData: Object,
		wizardDeps: Object,
		stepDeps: Object,
		loading: Boolean
	},
	data() {
		return {
			countryOptions: this.$cropOptions.countryOptions,
			acl: this.$inertia.page.props.acl,
			error: null,
		}
	},
	computed: {
		price: function() {
			const price = formatLocalizedNumber(this.wizardDeps.subscription.netPrice * (1 + this.wizardDeps.subscription.tax));
			return price + ' ' + __(this.wizardDeps.subscription.currency);
		},
		selectedPaymentMethod(){
			return this.wizardDeps.paymentMethods.find((item) => item.code === this.formData.payment_method_code) ?? null
		},
	},
	methods: {
		formatLocalizedNumber,
		paymentMethodUpdate(value){
			this.formData.payment_method_code = value;
		},
		async submitForm() {
			// todo disable button while executing
			if(this.loading){
				return;
			}

			const params = {id: this.wizardDeps.subscription.id};

			let promise = new Promise((resolve, reject) => {
				const response = axios.patch(
					this.$route("premium.payment_method.update", params),
					this.formData
				);

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			this.$toast.success('Änderung war erfolgreich!');

			this.$bus.$emit("modal:close");
			this.$bus.$emit("page:content:load");
			this.$bus.$emit("page:menu:load");
		},
		onError(error) {

			const errors = error.response.data.errors;
			// todo view mit fehlern aufrufen, nicht immer gibts nur 2 steps
			if(errors['bank_account.iban'] || errors['bank_account.owner']){
				this.$bus.$emit("wizard:back", errors)
			}

			if(errors['mollie']){
				this.error = errors['mollie'][0];
			}

			this.$bus.$emit("form:invalid", errors);
		},
	},
};
</script>
